module.exports = __webpack_public_path__ + "static/media/cacheit.b611b0f0.jpeg";